var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSharingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7_16557",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7_16557",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACa0lEQVRoge2ZwUsVURTGPw0So0LEMBWyTRK41Z34B7TR/gDFRQvDapkabcKNuhEU/wlJtxWIuslyYYUaaolIu0jQVKTIrO8wM7w7w70z80Ln3kfzwW/zzoX33XfnnnPmPCBXrly5/lddIU/IB3JMvpMF0kMuWHOVUk1ki/wxME+qrLlL0FWyA7P5gFekzI7FeA2hYPKQ9JIa0kiGyW8lfteSx1ipj06XJj6uxKcz9JUouZhPUTD3g1zUrGtR1mxk5i5BtfCeafUZ/0kqNGtblTXrWRmMUwfZhf6idmvWTyjx5xl51KqSTCJs+Bd5g/Alvk+ukZtkFOFL3Jm16UDNZBVh8zukDd7GNqE/EZUXsJRGJS0eR8xMIVyYbpA1mM3PwkIhqyYzESNH5J5hvZzEA/KW7PnMwbsX5WdpTDLFQ/+LjnwWSR8KabCdfImYf09un6WRf1EDvGbLdNTvyAg5UT47JWPQp8hMJQbizOv4Su7YMKvTI4SLzmNS79PvfxZtvq5bcWrQEgrm+jXxASW+Agc7RykygcE6TbxOiX/L0FdqqRuo18Qb4PgGJG0GBgc08UE4/ghJkVEvsWxCTkJ++UGUwCWWIiV5vmTTqEh+8bhNLMPhQhZITkLaBmkf5GIfkNfw2mDnW4liVGwzdwlesZR6sw+H5kJp2ulG8hHmR3MeludCSS80n2A2r2Y1q6k57Sul83OhuJf6kpkLyVjlJcLmpRCWzFxIFB1smTagzoWc2kAgdbTo9FzIpGcIX2In50Jxkj82tpGcRq3NhdLoFvkMs3krc6FidRleWy49k1Tuc5sL5cqVK9f56S+v1E3d8dFwXgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharingIcon);
export default __webpack_public_path__ + "static/media/sharing_icon.8f82249099f2a55a605d9cc04ccd76ac.svg";
export { ForwardRef as ReactComponent };